import React, { useState, useEffect } from 'react';
import { Button, TextField, MenuItem, Card, CardContent, Typography, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import addressService from '../service/addressService'; 
import FormInstructionBox from '../components/FormInstructionBox';

const cardStyle = {
  border: "1px solid",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
};

export default function SupplierAddressForm({ data, updateData, handleNext, handleBack, handleSave, mode, supplierID }) {
  const [addresses, setAddresses] = useState(data || []);
  const [address, setAddress] = useState(initialAddress());
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
 const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  
      const addressInstructions = [
         "Select the **Address Type** such as BILLING, HEAD QUARTERS, etc. so that we will used it for billing and contacts.",
        "If you have any questions or need more help. Please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128",
        "When you create or edit Address, After ADD ADRESS, You much click on Update/Submit/Save.",
        "Click 'Edit and Update' to apply changes, or 'Cancel' to discard."
    ];
  
  function initialAddress() {
    return {
      addressId: '',
      street1: '',
      street2: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
      addressType: 'BILLING',
      phone:'',
      email:''
    };
  }
  
  
  useEffect(() => {

      if(addresses){
            updateData(addresses);
      }
        }, [addresses]);

  const handleAddOrUpdate = () => {
    
    
              if (
    !address.addressType ||
    !address.street1 ||
    !address.street2 ||
    !address.city ||
    !address.state ||
    !address.country ||
    !address.postalCode ||
    !address.phone ||
    !address.email
  ) {
    alert("Please fill in all required fields.");
    return;
  }
    
  // Email format check (extra layer beyond type="email")
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(address.email)) {
    alert("Please enter a valid email address.");
    return;
  }
        
    
    if (isEditing) {
      const updated = [...addresses];
      updated[editingIndex] = address;
      setAddresses(updated);
      setIsEditing(false);
      setEditingIndex(null);
    } else {
      setAddresses(prev => [...prev, address]);
    }
    setAddress(initialAddress());
      setIsUpdateDisabled(false);
  };

  const handleEdit = (index) => {
    setAddress(addresses[index]);
    setEditingIndex(index);
    setIsEditing(true);
  };

  const handleDelete = (index) => {
    
  const addressAtIndex = addresses[index];

    if((mode && mode === "dashboard") && addressAtIndex?.addressId){
      
   if (window.confirm("Are you sure you want to delete this Address?")) {
    try {
     addressService.deleteSupplierSupplierAddresses(addressAtIndex.addressId,supplierID.supplierId);
    //  addressService.deleteAddress(addressAtIndex.addressId);
    const updated = addresses.filter((_, i) => i !== index);
    setAddresses(updated);
    // Reset if the item being edited is deleted
    if (isEditing && editingIndex === index) {
      setIsEditing(false);
      setEditingIndex(null);
      setAddress(initialAddress());
    }
   
    } catch (err) {
      console.error("Error deleting address:", err);
    }
       }
      
      
    }else{
    
    const updated = addresses.filter((_, i) => i !== index);
    setAddresses(updated);
    // Reset if the item being edited is deleted
    if (isEditing && editingIndex === index) {
      setIsEditing(false);
      setEditingIndex(null);
      setAddress(initialAddress());
    }
    }
  };

  const handleNextStep = () => {
    console.log(" address len "+ addresses.length);
      if(addresses.length==0){
      alert("Add atleast one address and then click next! ");
        return;
    }
    updateData(addresses);
    handleNext();
  };
  
    const handleUpdate = () => { 
 
      updateData(addresses);
      handleSave();
      setIsUpdateDisabled(true);
  };

  return (
    <div className="space-y-4">
      {/* Display Added Addresses */}
      {addresses.map((addr, index) => (
        <>
        <Card key={index} variant="outlined"  style={{ ...cardStyle, borderColor: "#F44336" }}>
          <CardContent className="flex justify-between items-center">
            <div>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" , textTransform: "uppercase"}}>{addr.addressType} Address</Typography>
              <Typography variant="body2">{addr.street1},{addr.street2}, {addr.city}, {addr.state}, {addr.country} - {addr.postalCode}</Typography>
              <Typography variant="body1">Phone: {addr.phone} Email: {addr.email}</Typography>
            </div>
            {!addr.addressId && (
            <div>
              <IconButton onClick={() => handleEdit(index)}><Edit /></IconButton>
              <IconButton onClick={() => handleDelete(index)}><Delete /></IconButton>
            </div>
            )}
          </CardContent>
        </Card>
<br/>
                </>
      ))}
      <br/>
      {/* Address Form */}
  <input type="hidden"  fullWidth value={address.addressId} onChange={e => setAddress({ ...address, addressId: e.target.value })} />
  <TextField select label="Address Type" fullWidth value={address.addressType} onChange={e => setAddress({ ...address, addressType: e.target.value })} required>
        <MenuItem value="BILLING">Billing</MenuItem>
        <MenuItem value="HEADQUARTERS">Headquarters</MenuItem>
        <MenuItem value="SHIPPING">Shipping</MenuItem>
      </TextField>
      <TextField label="Street Line 1" fullWidth value={address.street1} onChange={e => setAddress({ ...address, street1: e.target.value })} required />
<TextField label="Street Line 2" fullWidth value={address.street2} onChange={e => setAddress({ ...address, street2: e.target.value })} />
      <TextField label="City" fullWidth value={address.city} onChange={e => setAddress({ ...address, city: e.target.value })} required/>
      <TextField label="State" fullWidth value={address.state} onChange={e => setAddress({ ...address, state: e.target.value })} required/>
      <TextField label="Country" fullWidth value={address.country} onChange={e => setAddress({ ...address, country: e.target.value })} required/>
      <TextField label="ZIP Code" fullWidth value={address.postalCode} onChange={e => setAddress({ ...address, postalCode: e.target.value })} required/>
        <TextField label="Phone" fullWidth value={address.phone} onChange={e => setAddress({ ...address, phone: e.target.value })} required/>
          <TextField label="Email" fullWidth value={address.email} onChange={e => setAddress({ ...address, email: e.target.value })} required/>
    

      <Button variant="outlined" onClick={handleAddOrUpdate}>
        {isEditing ? 'Update Address' : 'Add Address'}
      </Button>
 {!(mode && mode === "dashboard") ? (
   <>
      {/* Navigation Buttons */}
      <div className="flex justify-between mt-4">
        <Button onClick={handleBack}>Back</Button>
        <Button variant="contained" onClick={handleNextStep}>Next</Button>
      </div>
  </>
   ) : ( 
          <>
                  <Button variant="contained" color="primary"  disabled={isUpdateDisabled} onClick={handleUpdate}>
            Update
          </Button>
</>
         )}
         
                      <FormInstructionBox 
                instructions={addressInstructions} 
                title="Address Details Guidelines" 
            />
    </div>
  );
}
